import axios from 'axios';
import { all, call, delay, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { getHeaderJWT, URL } from '../../../store/path';
import { handlError, parseError } from '../../app/serverError';
import { fetchedMaruti, fetchedPullOldSyncStatus, storeSearchMarutiResult, syncedUtd } from './actions';
// import URL from '../../../store/path'
import { isArray } from 'lodash';
import userACL from '../../../store/access';


//region Saga for sync utd

function* syncUtd() {
  yield takeEvery('SYNC_UTD_MARUTI', saveSyncUtd)
}

function* saveSyncUtd(action) {
  const { response, error } = yield call(udtAPI, action.payload)
  if (response) {
      yield put(syncedUtd({...action.payload,msg:response.data,}))
  }else {
    yield put(handlError(action, parseError(error)));
    if(error){
      if(error.response){
        if(error.response.status && error.response.status !== 200){
          yield put(syncedUtd({ ...action.payload, msg: {type: "error", msg: error.response.data.msg} }));
        }
      }
      
    }
    sagaErrorMessage(error, action);
  }
}

function udtAPI(data) {
  return axios.post(URL + '/report/maruti-sync-repost-utd/'+data.utd, {}, getHeaderJWT(), { crossDomain: true })
    .then(response => ({ response }))
    .catch(error => ({ error }))
}

//#region Saga for List Maruti 

function* fetchMaruti() {
  yield takeEvery('FETCH_MARUTI_SYNC', requestMaruti)
}


function* requestMaruti(action) {
  try {
    let { data } = yield call(requestMarutiAPI, action.payload)
    data = isArray(data) ? data : [data]
    yield put(fetchedMaruti(data))
  }
  catch (error) {
    sagaErrorMessage(error, action)
  }
}


function requestMarutiAPI(data) {
  let userAccess = userACL.atFetch()
  console.log("Maruti Sync : ",userAccess, data)
  // data.option = data.option.toUpperCase()
  // return axios.post(URL + '/report/maruti-sync', data, getHeaderJWT(), { crossDomain: true })
  return axios.post(URL + '/report/vb/maruti-sync', data, getHeaderJWT(), { crossDomain: true })
}

//#endregion


//#region Saga for Search Maruti 

function* searchMaruti() {

  yield takeLatest('SEARCH_MARUTI_SYNC', initiateSearch)

}

function* initiateSearch(action) {
  yield delay(350)
  let { data } = yield call(searchAPI, action.payload)
  yield put(storeSearchMarutiResult(data))

}

function searchAPI(data) {
  return axios.post(URL + '/report/maruti/search/' + data, data, getHeaderJWT(), { crossDomain: true })
}

//#endregion
function* repostRedisId() {
  yield takeEvery('REPOST_REDISID_SYNC', repostingRedisId)
}
function* repostingRedisId(action) {
  console.log('redisId', action)
  try {
    const { response, error } = yield call(repostRedisIdApi, action.payload)
    console.log('response', response)
  }
  catch (error) {
    sagaErrorMessage(error, action)
  }
}

function repostRedisIdApi(data) {
  return axios.get(URL + '/report/maruti-sync-repost/' + data, getHeaderJWT(), { crossDomain: true })
}

function* fetchOldSyncStatus() {
  yield takeEvery('PULL_OLD_SYNC_STATUS_MARUTI', requestOldSyncStatus)
}


function* requestOldSyncStatus(action) {
  try {
    let { data } = yield call(requestOldSyncStatusAPI, action.payload)
    // console.log(data,'=======================response-oldpull-sync')
    yield put(fetchedPullOldSyncStatus(data))
  }
  catch (error) {
    sagaErrorMessage(error, action)
  }
}


function requestOldSyncStatusAPI(data) {
  return axios.post(URL + '/report/maruti-sync/transfer', data, getHeaderJWT(), { crossDomain: true })
}

//#endregion

const sagaErrorMessage = (error, action) => {
  console.group("Saga Error:" + action.type)
  console.log(error)
  console.groupEnd()
}

export default function* marutiSyncSaga() {
  yield all([
    fetchMaruti(),
    searchMaruti(),
    repostRedisId(),
    fetchOldSyncStatus(),
    syncUtd()
  ])
}  